import React from 'react';
import styles from './AcfShadow.module.scss';
import className from 'classnames/bind';
import { WordPressBlocksViewer } from '@faustwp/blocks';
import { gql } from '@apollo/client';

let cx = className.bind(styles);

export default function AcfShadow(props) {
	const { shadow, attributes, innerBlocks } = props;
  const className = attributes.className?.split(' ') || [];

	return (
		<div className={cx(['ns_shadow', 'shadow', ...className, shadow.style && `style-${shadow.style}`])}>
      {React.createElement(WordPressBlocksViewer, { blocks: innerBlocks !== null && innerBlocks !== void 0 ? innerBlocks : [] })}
    </div>
	);
}

AcfShadow.fragments = {
	key: `AcfShadowFragment`,
	entry: gql`
		fragment AcfShadowFragment on AcfShadow {
			attributes {
				className
			}
      shadow {
        style
      }
		}
	`,
};


AcfShadow.config = {
	name: 'AcfShadow',
};
AcfShadow.displayName = 'AcfShadow';